import { userService } from '../services';

const state = {
  profileState: null
};

const actions = {
  getProfile({ commit }: any) {
    return userService.getProfile().then(
      profile => {
        commit('getProfileSuccess', profile);
        return profile;
      },
      error => console.log(error)
    );
  },

  editProfile({ dispatch, commit }: any, { user }: any) {
    userService.editProfile(user).then(
      () => {
        commit('editProfileSuccess', user);
        dispatch('alert/success', `Uživatel byl upraven.`, {
          root: true
        });
      },
      error => {
        dispatch('alert/error', JSON.stringify(error), {
          root: true
        });
      }
    );
  }
};

const mutations = {
  getProfileSuccess(state: any, profile: any) {
    state.profileState = profile;
  },
  editProfileSuccess(state: any, profile: any) {
    state.profileState.firstName = profile.firstName;
    state.profileState.lastName = profile.lastName;
  }
};

export const profile = {
  namespaced: true,
  state,
  actions,
  mutations
};
